import React, { useEffect, useMemo, useState } from 'react'
import System from 'src/helper/system';
import AdminConfig from "@system/config/admin";
import liveAuth from 'src/helper/liveAuth';
import { useDesignHubStore } from 'src/hooks/designHub';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleunknown from "src/assets/images/lifecycle-unknown.png";
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import Helper from "../helper/Helper";
import { Tooltip } from "../component/Global/Tooltip";
import NoResultContent from "./HomePageContent/NoResultContent";
import { AgGridReact } from "ag-grid-react";
import crosssignin from "src/assets/images/crossref-signin-icon.png";
import datasheet from "src/assets/images/download-datasheet.svg";

const CrossReferenceTool = () => {
  const [{ crossReferencePartList }, { get_cross_reference_parts }, { }] = useDesignHubStore()
  const [partDetail, setPartDetail] = useState({
    mfrPartNumber: ''
  });
  const [detailValidation, setDetailValidation] = useState({});
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const [__check] = useAxiosIndicatorCheck();
  const [selectedRowCount, setSelectedRowCount] = useState(0);
  const [farnellFormData, setFarnellFormData] = useState({})
  const [farnellPurchase, setFarnellPurchase] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const avUserInfo = liveAuth.getAvUserInfo()
  const [noResultError, setNoResultError] = useState(false)
  const [quoteCount, setQuoteCount] = useState(0);
  const [searchText, setSearchText] = useState('');
  const loadDataSheet = (e) => {
    const data = e?.data?.Datasheet ? e?.data?.Datasheet : '';
    return data && <>
      <a href={data} className='text-black' target="_blank"> <img src={datasheet} className="me-2" />Data Sheet</a>
    </>
  }

  const getImageOnStatus = (status) => {
    if (status === 'low') {
      return lifecyclegreen;
    }
    if (status === 'med') {
      return lifecycleyellow;
    }
    if (status === 'high') {
      return lifecyclered;
    }
    if (status === 'unknown') {
      return lifecycleunknown;
    }
    return false;
  };

  const loadLifecycle = (e) => {
    const data = e?.data?.LifeCycle ? e?.data?.LifeCycle : '';
    return data && <><img className="me-2" src={getImageOnStatus(e?.data?.LifeCycle?.toLowerCase())} alt={''} />{e?.data?.LifeCycle}</>
  }

  const renderTooltip = (props) => (
    <div>
      <div className="text-center">LOW RISK:<br />
        Part listed as active by Manufacturer. Suitable for new and existing designs.</div><br />
      <div className="text-center">MEDIUM RISK:<br />
        Part not confirmed as active by Manufacturer. Presents increased risk of obsolescence. Exercise caution in using for a new design.</div><br />
      <div className="text-center">HIGH RISK:<br />
        Part identified as End Of Life (EOL).
      </div>
      <div className="text-center">UNKNOWN:<br />
        Lifecycle information not available.
      </div>
    </div>
  );

  const externalUser = [
    { field: '', pinned: 'left', filter: 'agTextColumnFilter', lockPosition: "left", headerCheckboxSelection: true, checkboxSelection: true, showDisabledCheckboxes: true, width: 50 },
    { field: 'ManufacturerName', pinned: 'left', lockPosition: "left", minWidth: 200, headerName: 'MANUFACTURER NAME', headerTooltip: 'MANUFACTURER NAME', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'ManufacturerPartNumber', pinned: 'left', lockPosition: "left", minWidth: 200, headerName: 'MANUFACTURER PART NUMBER', headerTooltip: 'MANUFACTURER PART NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'Description', minWidth: 150, pinned: 'left', lockPosition: "left", headerName: 'DESCRIPTION', headerTooltip: 'DESCRIPTION', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'Datasheet', minWidth: 150, headerName: 'DATASHEET', headerTooltip: 'DATASHEET', cellClass: 'stringType', comparator: Helper.textSortingAgGrid, cellRenderer: loadDataSheet },
    { field: 'MatchRate', minWidth: 150, headerName: 'MATCH RATE', headerTooltip: 'MATCH RATE', sortable: true, cellClass: 'stringType' },
    { field: 'SimilarityType', minWidth: 200, headerName: 'SIMILARITY TYPE', headerTooltip: 'SIMILARITY TYPE', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'LifeCycle', minWidth: 150, sortable: true, comparator: Helper.textSortingAgGrid, cellRenderer: loadLifecycle, cellClass: 'stringType' }
  ]
  const internalUser = [
    { field: '', pinned: 'left', filter: 'agTextColumnFilter', lockPosition: "left", headerCheckboxSelection: true, checkboxSelection: true, showDisabledCheckboxes: true, width: 50 },
    { field: 'ManufacturerName', pinned: 'left', lockPosition: "left", width: 200, headerName: 'MANUFACTURER NAME', headerTooltip: 'MANUFACTURER NAME', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'SAPPartNumber', pinned: 'left', lockPosition: "left", width: 200, headerName: 'SAP PART NUMBER', headerTooltip: 'SAP PART NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'DRFlag', width: 120, pinned: 'left', headerName: 'DR/DW', headerTooltip: 'DR/DW', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'Description', minWidth: 200, headerName: 'DESCRIPTION', headerTooltip: 'DESCRIPTION', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'Datasheet', minWidth: 150, headerName: 'DATASHEET', headerTooltip: 'DATASHEET', cellClass: 'stringType', comparator: Helper.textSortingAgGrid, cellRenderer: loadDataSheet },
    { field: 'MatchRate', minWidth: 150, headerName: 'MATCH RATE', headerTooltip: 'MATCH RATE', sortable: true, cellClass: 'stringType' },
    { field: 'Stock', minWidth: 150, headerName: 'STOCK', headerTooltip: 'STOCK', sortable: true, cellClass: 'stringType', comparator: Helper.numberSortingAgGrid },
    { field: 'LeadTime', minWidth: 150, headerName: 'LEAD TIME', headerTooltip: 'LEAD TIME', sortable: true, cellClass: 'stringType', comparator: Helper.numberSortingAgGrid },
    { field: 'SimilarityType', minWidth: 200, headerName: 'SIMILARITY TYPE', headerTooltip: 'SIMILARITY TYPE', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'LifeCycle', minWidth: 150, sortable: true, comparator: Helper.textSortingAgGrid, cellRenderer: loadLifecycle, cellClass: 'stringType' }
  ]

  const fetchCrossReferencePart = async () => {
    if (validateField()) {
      setSearchText(partDetail.mfrPartNumber.trim())
      await get_cross_reference_parts({ ERPMFRPartNumber: partDetail.mfrPartNumber.trim() });
    }
  }

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field]
    }
    setPartDetail({ ...partDetail, [field]: value });
  }

  const validateField = () => {
    let validationModal = {}
    Helper.valueIsNotNull(partDetail.mfrPartNumber) ? "" : validationModal.mfrPartNumber = "Please enter the Manufacturer Part Number.";
    setDetailValidation(validationModal)
    return Object.keys(validationModal).length <= 0;
  }

  useEffect(() => {
    let _data = [];
    if (crossReferencePartList && crossReferencePartList?.products?.length > 0) {
      if (crossReferencePartList?.products.length === 1 && crossReferencePartList.products.filter(x => x.type === 'SOURCE').length === 1) {
        setNoResultError(true)
      } else {
        setNoResultError(false)
      }

      if (System.validateDomain(avUserInfo?.email)) {
        crossReferencePartList?.products?.map((_product, idx) => {
          let inputData = {
            ManufacturerName: Helper.valueIsNotNull(_product.manufacturerName) ? _product.manufacturerName : '',
            ManufacturerPartNumber: Helper.valueIsNotNull(_product.materialDescription)
              ? _product.materialDescription
              : (_product.type === "SOURCE" && Helper.valueIsNotNull(_product.original)
                ? _product.original
                : ""),
            Description: Helper.valueIsNotNull(_product.description) ? _product.description : '',
            Datasheet: Helper.valueIsNotNull(_product.datasheet) ? _product.datasheet : '',
            MatchRate: _product.match ? _product.match + '%' : '',
            SimilarityType: Helper.valueIsNotNull(_product.similarity) ? _product.similarity : '',
            LifeCycle: Helper.valueIsNotNull(_product.lifeCycleRisk) ? _product.lifeCycleRisk : '',
            Product: _product
          }
          _data.push(inputData);
        });
        setRowData(_data);
        setColumnDefs(externalUser);
      }
      else {
        crossReferencePartList?.products?.map((_product, idx) => {
          let inputData = {
            ManufacturerName: Helper.valueIsNotNull(_product.manufacturerName) ? _product.manufacturerName : '',
            SAPPartNumber: Helper.valueIsNotNull(_product.materialDescription)
              ? _product.materialDescription
              : (_product.type === "SOURCE" && Helper.valueIsNotNull(_product.original)
                ? _product.original
                : ""),
            DRFlag: Helper.valueIsNotNull(_product.dr) ? _product.dr : '',
            Description: Helper.valueIsNotNull(_product.description) ? _product.description : '',
            Datasheet: Helper.valueIsNotNull(_product.datasheet) ? _product.datasheet : '',
            MatchRate: _product.match ? _product.match + '%' : '',
            Stock: Helper.valueIsNotNull(_product.stock) ? _product.stock + ' units' : '',
            LeadTime: _product?.leadTime?.length > 0 ? Math.max(..._product?.leadTime.map(o => o?.weeks)) + ' Weeks' : '',
            SimilarityType: Helper.valueIsNotNull(_product.similarity) ? _product.similarity : '',
            LifeCycle: Helper.valueIsNotNull(_product.lifeCycleRisk) ? _product.lifeCycleRisk : '',
            Product: _product
          }
          _data.push(inputData);
        });
        setRowData(_data);
        setColumnDefs(internalUser);
      }
    }
  }, [crossReferencePartList])

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      resizable: true
    };
  }, []);

  const onSelectionChanged = () => {
    validateAddToQuote();
    setSelectedRowCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const excelStyles = useMemo(() => {
    return [
      { id: 'numberType', numberFormat: { format: '0' }, },
      { id: 'negativeInBrackets', numberFormat: { format: '$[blue] #,##0;$ [red](#,##0)', }, },
      { id: 'booleanType', dataType: 'Boolean', },
      { id: 'stringType', dataType: 'String', },
      { id: 'dateType', dataType: 'DateTime', },
    ];
  }, []);

  const validateAddToQuote = () => {
    let validCount = 0;
    if (gridRef?.current?.api?.getSelectedRows().length > 0) {
      gridRef?.current?.api?.getSelectedRows().forEach(element => {
        if (Helper.valueIsNotNull(element?.Product?.erpPartNumber) &&
          Helper.valueIsNotNull(element?.Product?.itemNumber) &&
          element?.Product?.qtyMin > 0 &&
          element?.Product?.qtyMult > 0 &&
          Helper.valueIsNotNull(element?.Product?.erpManufacturerName) &&
          Helper.valueIsNotNull(element?.Product?.manufacturerPartNumber) &&
          Helper.valueIsNotNull(element?.Product?.manufacturerName) &&
          Helper.valueIsNotNull(element?.Product?.manufacturerCode) &&
          Helper.valueIsNotNull(element?.Product?.erpManufacturerCode)) {
          validCount += 1;
        }
      });
    }
    setQuoteCount(validCount);
  }

  const isGuestFullRights = () => {
    return (_check_p('PDG_ADD_TO_CART').status &&
      _check_p('PDG_ADD_TO_BOM').status &&
      _check_p('PDG_CLICK_TO_QUOTE').status);
  }

  const addToQuote = async () => {

    let selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length > 0) {
      store.dispatch(system_notification({
        name: 'ValidateRFQQuoteRequest',
        data: {
          quoteFrom: 'CrossReference',
          quoteList: selectedRows
        },
      }));
    }
  }

  const onFarnellPurchase = () => {
    let params = [];
    if (gridRef.current.api.getSelectedRows().length > 0) {
      gridRef.current.api.getSelectedRows().map((v) => {
        params.push({
          MANUFACTURER_PID: Helper.valueIsNotNull(v?.Product?.materialDescription)
            ? v?.Product?.materialDescription
            : (v?.Product?.type === "SOURCE" && Helper.valueIsNotNull(v?.Product?.original)
              ? v?.Product?.original
              : ""),
          QUANTITY: '1', // default qty set as 1
          SUPPLIER_ID_DUNS: 'Avnet'
        })
      });
      let formObj = { "ITEM": params }
      setFarnellFormData(JSON.stringify(formObj))
      setFarnellPurchase(true);
    }
  }

  useEffect(() => {
    if (farnellPurchase && JSON.stringify(farnellFormData).length > 0) {
      console.log('Farnell Form Data ', farnellFormData)
      let button = document.getElementById("farnellsubmit");
      button.click();
      setFarnellPurchase(false)
    }
  }, [farnellPurchase])

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onExportAll = async () => {
    const allColumnState = gridColumnApi.getColumnState();
    const customColumns = allColumnState
      .filter((column) => column.hide !== true && column.colId != '0')
      .map((column) => column.colId);
    let params = { fileName: `cross_reference.xlsx`, sheetName: "cross_reference", columnKeys: customColumns };
    gridRef.current.api.exportDataAsExcel(params);
  }

  const onDRMSRegister = () => {
    System.popup('RegisterDesignPopup', {})
  }

  return (
    <div id='crossreference'>
      <div className='container'>
        {!liveAuth.check() && <div className='signin whitebg border'>
          <div className='row'>
            <div className='col-md-9'>
              <div className='d-flex'>
                <img src={crosssignin} className='me-3' />
                <div>
                  <div className='font-oswald font-light font-24 text-green mb-3'>Sign In or Register</div>
                  <p>Already have an account? Sign in to use the cross reference tool and access all the features and services of Design Hub. Need an account? <a href={AdminConfig.getRegistrationURL()} className='text-green'> Register here.</a></p>
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <a className="btn bs5 btn-primary upload-button w-100 mt-5" href={System.getLoginPageUrl()}>Sign In</a>
            </div>
          </div>
        </div>
        }
        {liveAuth.check() && <div className='crossreference-mafsearch whitebg border'>
          <p className='font-16'>Use this feature to search and compare alternatives for specific parts and products. Enter a complete Manufacturer Part Number: </p>
          <div className='d-flex align-items-center'>
            <input type='text' className={`form-control form-control-sm me-3 mt-2 ${detailValidation && detailValidation.mfrPartNumber ? ' error' : ''}`} placeholder=' Manufacturer Part Number' onKeyDown={(e) => e.key == 'Enter' && fetchCrossReferencePart()} onChange={({ target: { value } }) =>
              onValueChange("mfrPartNumber", value)
            } />
            {__check(['CROSS_REFERENCE_SEARCH_PART_API_CALL']).status &&
              <button type="button" className="btn bs5 btn-primary upload-button w180 mt-2"
                      disabled={true}>
                <i className="fa fa-spinner fa-spin" />
              </button>
            }
            {!__check(['CROSS_REFERENCE_SEARCH_PART_API_CALL']).status &&
              <button className="btn bs5 btn-primary upload-button w180 mt-2" onClick={(e) => fetchCrossReferencePart()}>Search</button>
            }

          </div>
          {detailValidation.mfrPartNumber && <p className="error"> {detailValidation.mfrPartNumber}</p>}
        </div>}
      </div>

      {(!crossReferencePartList || !Object.keys(crossReferencePartList).length) &&
        <>
          <div className='bg-grey2 crossref-step-container'>
            <div className='container'>
              <h2 className='font-oswald font-light font-38 text-black position-relative mb-5'>How to Use the Tool</h2>
              <div className='row'>
                <div className='col-md-4 mb-2'>
                  <div className='crossref-step-box'>
                    <div className='crossref-step-title'>
                      Step One
                    </div>
                    <p>Enter the manufacturers’ complete part number into the box above and press search.</p>
                  </div>
                </div>
                <div className='col-md-4 mb-2'>
                  <div className='crossref-step-box'>
                    <div className='crossref-step-title'>
                      Step Two
                    </div>
                    <p>Compare and select alternative solution from the results.</p>
                  </div>
                </div>
                <div className='col-md-4 mb-2'>
                  <div className='crossref-step-box'>
                    <div className='crossref-step-title'>
                      Step Three
                    </div>
                    <p>Purchase prototypes from Farnell or request high volume pricing from Avnet/SB Name.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='container '>
            <div className='about-crossref'>
              <h3 className='font-oswald font-light font-30 text-darkgreen mb-3'>About Avnet’s Cross Reference Tool</h3>
              <p>Avnet is advancing the integration of artificial intelligence techniques into our solutions, enhancing efficiencies and delivering value to our customers and suppliers.​ This cross-reference tool exemplifies our application of AI methodologies. The results you obtain through this tool are derived from the following data sources:​</p>
              <ul>
                <li>Supplier-provided cross-references</li>
                <li>Avnet’s technical team expertise</li>
                <li>Avnet’s extensive parametric-level data from a wide array of suppliers</li>
              </ul>
              <p>
                Please be advised that although the provided information and suggested alternatives are intended to closely match your original specifications, it is crucial to thoroughly review the manufacturers' datasheets to verify that the proposed solution meets the functional requirements of your intended application.
              </p>
              <p><strong>If you need further information or advice, please contact your local Avnet team <a href="mailto:OnlineSupportUS@avnet.com">OnlineSupportUS@Avnet.com</a></strong> </p>
            </div>
          </div>
        </>}
      {!__check(['CROSS_REFERENCE_SEARCH_PART_API_CALL']).status && crossReferencePartList && Object.keys(crossReferencePartList).length > 0 && crossReferencePartList?.products?.length > 0 &&
        <div className='mx-2 adminconsole-container'>
          {rowData?.length > 0 && !noResultError ?
            <>
              <div className='all-content'>
                <div className='all-content-header'>
                  <div className="d-flex justify-content-between align-item-center">
                    <div className='font-arial font-16'><b>Showing {rowData?.length} Matches for : {searchText}</b>
                    </div>
                    <div className='d-flex text-end mb-1'>
                      <Tooltip
                        position={'bottom center'}
                        opener={() => (
                          <div className='text-blue2'> <i className="fa fa-info-circle font-15 text-black" aria-hidden="true"></i> Lifecycle </div>
                        )}
                        content={() => (
                          renderTooltip()
                        )}
                      />
                      <a href={void (0)} onClick={() => onExportAll()} className='ms-2'>
                        <i className="fa fa-download me-1 text-black" aria-hidden="true"></i> Export List
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-end'>
                {System.validateDomain(avUserInfo?.email) &&
                  <>
                    {liveAuth.check() && <button className={`bs5 btn btn-secondary mb-3 ${(quoteCount > 0 && quoteCount === gridRef?.current?.api?.getSelectedRows().length) ? '' : ' disabled'}`} onClick={() => addToQuote()}>
                        Add item({quoteCount}) to Quote
                      </button>
                    }
                    <button className={`bs5 btn btn-primary mb-3 ms-2 ${selectedRowCount > 0 ? '' : ' disabled'}`} onClick={() => onFarnellPurchase()}>
                      Purchase From  Farnell
                    </button>
                  </>
                }
                {!System.validateDomain(avUserInfo?.email) &&
                  <button className={`bs5 btn btn-primary mb-3 ms-2 text-uppercase`} onClick={() => onDRMSRegister()}>
                    DRMS - Register Now
                  </button>
                }
      
              </div>
              <div className="ag-theme-alpine ag-grd-hg mb-5">
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={'multiple'}
                  suppressRowClickSelection={true}
                  excelStyles={excelStyles}
                  onGridReady={onGridReady}
                  onSelectionChanged={onSelectionChanged}
                  autoGroupColumnDef={{
                    headerName: 'Group',
                    minWidth: 220,
                  }}
                >
                </AgGridReact>
              </div>
            </>
            :
            <>
              <div className='container mt-5'>
                <NoResultContent message={`Sorry! No search result found.`}
                                 isDisplay={false} />
              </div>
            </>
          }
        </div>
      }
      
      <form className="d-none" encType="application/x-www-form-urlencoded" target="_blank" action={`https://uk.farnell.com/PFConfigurator?CMP=${System.getFarnellCMPUrl()}&type=AVNET&langId=44`} id="farnellcart" method="post" name="farnellcart" >
        <input id="result" name="result"
               value={farnellFormData}
        />
        <input type="submit" value="Farnell Cart" id="farnellsubmit" />
      </form>
    </div>
  )
}



export default CrossReferenceTool
